<template>
  <div>
  
    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Financial Data</div>
          <div class="panal-body">
            <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>
            <div class="app-All" v-if="OnlineReceipt.length > 0">
              <div class="app-stu col-md-4 col-sm-12">
                <div class="title">Total Credit : <span> {{OnlineReceipt[0].TotalCredit ? OnlineReceipt[0].TotalCredit : ''}} </span></div>
              </div>
              <div class="app-stu col-md-4 col-sm-12">
                <div class="title">Total Debit: <span>{{OnlineReceipt[0].TotalDebit ? OnlineReceipt[0].TotalDebit : '' }}</span></div>
              </div>
              <div class="app-stu col-md-4 col-sm-12">
                <div class="title">
                  Total UnPaid Debit : <span>{{OnlineReceipt[0].TotalUnPaid ? OnlineReceipt[0].TotalUnPaid : ''}}</span>
                </div>
              </div>
              <div class="app-stu col-md-4 col-sm-12">
                <div class="title">Available Credit : <span>{{OnlineReceipt[0].AvailableCredit ? OnlineReceipt[0].AvailableCredit : ''}}</span></div>
              </div>
              <div class="app-stu col-md-8 col-sm-12">
                <div class="title">Current Balance : <span>{{OnlineReceipt[0].TotalBalance ? OnlineReceipt[0].TotalBalance : ''}}</span></div>
              </div>
            </div>
            <div class="app-stu-photo">
              <img src="../../assets/SU_Logo.png" />
            </div>

            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>

   
    
  </div>
</template>
<script>
import studentData from '../../services/student/studentDataServices';
export default {
  
  name: "FinancialData",
  data() {
    return {
      selected: null,
      show: true,
      OnlineReceipt: '',
      isHidden: false,
      message: '',
      options: [
          { value: null, text: 'Select Method' },
          { value: 'a', text: 'Cash' },
          { value: 'b', text: 'Bank' },
          { value: 'c', text: 'Check' },
          { value: 'd', text: 'transfer' },

     ],
     
    };
  },
  computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },

       mounted(){
      
      //this.currenUser.StudentID  //4
            studentData.GetStudentBasicFinancialData(this.currenUser.StudentID).then(Response =>{
              // this.isLoading = false ;
               this.OnlineReceipt = Response.data
               // this.empty =false
                // eslint-disable-next-line no-console
                  console.log(this.OnlineReceipt)
           },
         error => {
              
                  // eslint-disable-next-line no-console
                  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
       
       
       },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #50bd77;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.app-All {
  width: 75%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;

  float: left;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

.bg-filter {
  background: #cacaca;
  padding: 10px;
  width: 100%;
}
.show {
  display: none;
}
.badge {
  padding: 0.65em 0.6em;
}
</style>
